import { render, staticRenderFns } from "./customPayment.vue?vue&type=template&id=060ad664&scoped=true&"
import script from "./customPayment.vue?vue&type=script&lang=js&"
export * from "./customPayment.vue?vue&type=script&lang=js&"
import style0 from "./customPayment.vue?vue&type=style&index=0&id=060ad664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060ad664",
  null
  
)

export default component.exports